import config from 'config';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';

import { resetClass } from 'srcReact/helpers/utils';
import { alertActions } from 'srcReact/Alert';
import { subscriptionActions } from 'srcReact/SubscriptionPage';
import Spinner from 'srcReact/components/common2/Spinner';

class CallbackCheckoutEditPageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { redirectHome: false }

        let query = queryString.parse(location.search)
        if (query && query.organization_id && query.state && query.new_plan && (query.id || query.subscription_id)) {
            if (query.id) {
                this.props.updateSubscriptionAfterCheckout(query.organization_id, query.id, query.state, '', query.new_plan)
            } else if (query.subscription_id) {
                this.props.updateSubscriptionAfterCheckout(query.organization_id, '', query.state, query.subscription_id, query.new_plan)
            }
        } else {
            // this.state.redirectHome = true
            // this.props.errorAlerts(this.props.t('error.not_authorized'))
            window.location = `${config.webUrl}/0/workplaces`
        }

        resetClass(document.body, 'callback-checkout-edit-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('callback-checkout-edit-page');
    }

    componentDidUpdate() {
        const { subscriptionPlan } = this.props;
        if (subscriptionPlan && subscriptionPlan.updated) {
            setTimeout(function () { window.location = `${config.webUrl}/0/workplaces` }, 2000);
        }
    }

    render() {
        const { t, alert, user, subscriptionPlan } = this.props;
        const { redirectHome } = this.state;
        return (
            <React.Fragment>
                {redirectHome && alert && alert.message &&
                    <div className="loader-container d-flex justify-content-center align-items-start pt-3">
                        <p className="alert alert-danger text-center">{alert.message}<br /><Spinner/></p>
                    </div>
                }
                {!redirectHome && subscriptionPlan && (subscriptionPlan.loading || subscriptionPlan.updated) &&
                    <div className="loader-container d-flex justify-content-center align-items-center pt-3">
                        <p className="text-center text-green mb-0">
                            {subscriptionPlan.updated && (<React.Fragment>{t('billing.pricing.checkout.subscriptionUpdated')}<br /></React.Fragment>)}
                            <Spinner/>
                        </p>
                    </div>
                }
                {!redirectHome && subscriptionPlan && subscriptionPlan.error &&
                    <p className="mt-3 alert alert-danger text-center">{t('error.occured')}</p>
                }
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    const { alert, organization, subscription } = state;
    const { current_organization } = organization;
    const { loggingIn, user } = state.login;
    const { subscriptionPlan } = subscription;
    return { alert, loggingIn, user, current_organization, subscriptionPlan }
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    errorAlerts: alertActions.error,
    updateSubscriptionAfterCheckout: subscriptionActions.updateAfterCheckout
};

const ExtendedComponent = withTranslation('common')(CallbackCheckoutEditPageContainer);

const connectedCallbackCheckoutEditPageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent);
export { connectedCallbackCheckoutEditPageContainer as CallbackCheckoutEditPageContainer };
